module.exports = __webpack_public_path__ + "img/Invasion-PDAC_GSE202740.c8a12c84.png";